import { Component,
         Output,
         OnInit,
         EventEmitter }             from '@angular/core';
import { TableColumn,
         TableColumnType }          from './../common/table-column';
import { ISortableFilter }          from './../common/sortable-filter';
import { BusService }               from './../shared/bus.service';
import { PeakService }              from './../shared/peak.service';
import { BusSortableFilter }        from './bus-sortable-filter';
import { BusDialogComponent,
         CrewMember }               from './../bus-dialog/bus-dialog.component';
import { SavingDialogComponent }    from './../common/saving-dialog.component';
import { BusModel }                 from './bus.model';
import { MatDialog }                from '@angular/material';
import { Globals }                  from './../common/globals';
import { BusCrewService }           from '../shared/bus-crew.service';
import { Observable }               from 'rxjs/Observable';

@Component({
  selector: 'sa-bus-list',
  template: require('./bus-list.component.html'),
  styles: [require('./bus-list.component.scss')],
  providers: [BusCrewService]
})
export class BusListComponent implements OnInit {

  @Output() columns: Array<TableColumn>;
  @Output() filter = new BusSortableFilter('busNumber');
  @Output() performSearch = new EventEmitter();
  @Output() productUpdated = new EventEmitter();

  public getDataCallback: Function;

  private apiService: BusService;

  private primaryBusDrivers: any[];

  constructor(
    apiService: BusService,
    private dialog: MatDialog,
    public globals: Globals,
    private busCrewService: BusCrewService
  ) {
    this.apiService = apiService;
    this.getDataCallback = this.getData.bind(this);
    this.filter.activeOnly = true;

    this.columns = [
      new TableColumn(TableColumnType.Text, 'busNumber', 'Číslo autobusu', 100),
      new TableColumn(TableColumnType.Text, 'regPlate', 'SPZ', 60),
      new TableColumn(TableColumnType.Text, 'busType', 'Typ autobusu', 150),
      new TableColumn(TableColumnType.Bool, 'active', 'Aktivní', 80)
    ];
  }

  private getData(filter: ISortableFilter) {
    return this.apiService.getItems(filter);
  }

  private getDriversData() {
    this.busCrewService.getPrimaryDrivers()
          .subscribe(resp => {
            this.primaryBusDrivers = resp;
      });
  }

  public addNew() {
    let dialogRef = this.dialog.open(BusDialogComponent, {disableClose: true});
    dialogRef.componentInstance.model = new BusModel();
    dialogRef.componentInstance.newItem = true;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.insertItem(dialogRef.componentInstance.model)
        .subscribe(res => {
            cloakRef.close();
            this.search();
          });
      }
    });
  }

  public search() {
    this.getDriversData();
    this.performSearch.emit(this.filter);
  }

  public editItem(model: BusModel) {
    let dialogRef = this.dialog.open(BusDialogComponent, {disableClose: true});
    dialogRef.componentInstance.model = model;
    dialogRef.componentInstance.model.allPrimaryBusDrivers = this.primaryBusDrivers;
    dialogRef.componentInstance.newItem = false;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.updateItem(dialogRef.componentInstance.model.busID.toString(), dialogRef.componentInstance.model)
          .subscribe(res => {
            cloakRef.close();
            console.log('Bus updated');
            this.search();
          });
      } else if (result === 'delete') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.deleteItem(dialogRef.componentInstance.model.busID.toString())
          .subscribe(
            data => {
              cloakRef.close();
              console.log('Bus deleted');
              this.search();
          },
            err => {
              cloakRef.close();
              window.alert('Vybraná položka nemohla být odstraněna.');
            }
          );
      } else {
        this.search();
      }
    });
  }

  ngOnInit() {
    this.getDriversData();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/bus-list/bus-list.component.ts